// @ts-check

/**
 * Nombres legibles para herramientas del agente de estimación (UIMessage tool parts).
 * Claves: nombre de herramienta tal como llega en `tool-{name}` o `dynamic-tool.toolName`.
 */
/** @type {Record<string, string>} */
export const AGENT_TOOL_DISPLAY_LABELS = {
  get_standard_optional_modules: "Módulos estándar: opcionales",
  get_standard_non_optional_modules: "Módulos estándar: obligatorios",
  get_standard_non_optional_fixed_time_modules:
    "Módulos estándar: obligatorios con tiempo fijo",
  get_previous_estimation_examples: "Ejemplos de estimaciones anteriores",
  get_standard_tech_stack: "Stack tecnológico estándar",
  get_memory: "Consulta de memoria",
  get_feedback: "Consulta de retroalimentación pasada",
  set_memory: "Actualizar memorias",
  add_feedback: "Agregar retroalimentación",
  new_feedback: "Agregar retroalimentación",
  edit_feedback: "Editar retroalimentación",
  update_feedback: "Editar retroalimentación",
  delete_feedback: "Eliminar retroalimentación",
  web_search: "Búsqueda web",
  ask_questions: "Preguntas al usuario",
  calculate: "Operaciones aritméticas",
}

/**
 * @param {string} toolName
 * @returns {string}
 */
function formatToolNameFallback(toolName) {
  const t = toolName.trim()
  if (!t) return "Herramienta"
  return t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
}

/**
 * @param {string | undefined | null} toolName
 * @returns {string}
 */
export function getAgentToolDisplayLabel(toolName) {
  if (typeof toolName !== "string" || !toolName.trim()) return "Herramienta"
  const key = toolName.trim()
  const mapped = AGENT_TOOL_DISPLAY_LABELS[key]
  if (mapped !== undefined) return mapped
  return formatToolNameFallback(key)
}
